export default __webpack_public_path__ + "static/media/hippie_graphics_01_text_01_website.43eac777.svg";